import React, { useState, useEffect } from 'react'
import { Outlet, Navigate, useLocation } from 'react-router-dom'
import Navigation from '../components/Navigation'
import Navbar from '../components/Navigation/Navbar'
import { session } from '../utils/AuthSession'

function MainLayout() {
    const [authSession] = useState(session())
    const location = useLocation()
    const isPublicRoute = location.pathname === '/' || location.pathname.startsWith('/product')

    if(authSession || isPublicRoute){
        const showChrome = Boolean(authSession)
        const showNavbar = authSession || isPublicRoute
        return (
            <div className='relative h-screen bg-[#F6F8F9]'>
                    {showNavbar && <Navbar showLogin={!authSession && isPublicRoute} />}
                    <div id="main-app-scroll-container" className={`${showNavbar ? 'pt-16' : ''} ${showChrome ? 'pb-16' : ''} h-full overflow-auto scrollbar-hide`}>
                        <Outlet />
                    </div>
                    {showChrome && <Navigation />}
            </div>
        )
    }else{
        return (
            <Navigate to="/auth/login" replace={true} />
        )
    }
    
}

export default MainLayout
